import { X } from "react-feather";
import styles from "../tour.module.css";
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

const EventViewPopup = (props) => {

  return (<>
    <DialogTitle id="alert-dialog-title">
      Event
      <button onClick={(e) => props.setViewEventOpen2(false)}><X /></button>
    </DialogTitle>

    <DialogContent>
      <DialogContentText>
        <div className={`${styles.CalendarEditPopup}`}>
          <ul>
            <li>
              <p className={`${styles.CalendarEditPopupTitle}`}>Title:</p>
              <p className={`${styles.CalendarEditPopupCon}`}>{props?.selectedEvent?.title}</p>
            </li>
            <li>
              <p className={`${styles.CalendarEditPopupTitle}`}>Property:</p>
              <Link className={`${styles.CalendarEditPopupCon}`} to={"/properties/details/" + props?.selectedEvent?.extendedProps?.property_id}>{props?.selectedEvent?.extendedProps?.property_name}</Link>
            </li>
            <li>
              <p className={`${styles.CalendarEditPopupTitle}`}>Date:</p>
              <p className={`${styles.CalendarEditPopupCon}`}>{dayjs(props?.selectedEvent?.extendedProps?.date_time).format("MM/DD/YYYY hh:mmA")}</p>
            </li>
          </ul>
        </div>
      </DialogContentText>
    </DialogContent>

    <DialogActions>
      <Button className="CancelPopupBU" onClick={(e) => { props.setViewEventOpen2(false); props.setOpenDeleteModal(true); }}>Delete</Button>
      <Button className="SubmitPopupBU" onClick={(e) => { props.setViewEventOpen2(false); props.setEditEventOpen(true); }}>Update</Button>
    </DialogActions>
  </>);
};

export default EventViewPopup;
